import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { DataAccessPolicy, ExternalDataAccess, instanceofExternalDataAccess } from '@mtna/pojo-consumer-ts';

@Pipe({ name: 'rdsIsExternalDataAccess' })
export class RdsIsExternalDataAccessPipe implements PipeTransform {
  transform(dataAccessPolicy: DataAccessPolicy | undefined): ExternalDataAccess | undefined {
    if (instanceofExternalDataAccess(dataAccessPolicy)) {
      return dataAccessPolicy;
    } else {
      return undefined;
    }
  }
}

@NgModule({
  exports: [RdsIsExternalDataAccessPipe],
  declarations: [RdsIsExternalDataAccessPipe],
})
export class RdsIsExternalDataAccessPipeModule {}
